import { createShorthandFactory } from '@flowio/react-helpers';
import PageActions from '../components/PageActions';
export default createShorthandFactory(PageActions, function (value) {
  return {
    actions: Array.isArray(value) ? value : [value]
  };
});